import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { Container as i, Content as s, CloseButton as a } from "./styles.js";
import { Close as m } from "../../foundations/icons/Close.js";
const f = ({ status: r = "warning", onClose: o, children: n, ...e }) => /* @__PURE__ */ l(i, { $styleStatus: r, ...e, children: [
  /* @__PURE__ */ t(s, { children: n }),
  o ? /* @__PURE__ */ t(a, { ariaLabel: "Close", onClick: o, children: /* @__PURE__ */ t(m, {}) }) : null
] });
export {
  f as Alert
};
//# sourceMappingURL=Alert.js.map
